<template>
  <div>
    <div :class="className" :key="reloadFast">
      <validation-observer ref="shipmentRules">
        <b-row class="pt-2">
          <b-col cols="6">
            <b-form-group>
              <label>Service Mode </label>
              <Select2
                :disabled="true"
                placeholder="Select Service Type"
                v-model="service_type"
                :options="service_types"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group>
              <label>Detail Service </label>
              <Select2
                :disabled="readonlyFrom"
                placeholder="Select Detail Service"
                v-model="detail_service"
                :options="
                  fast_services.filter((i) => i.service_type == service_type)
                "
              />
            </b-form-group>
          </b-col>
        </b-row>
        <div v-if="service_type != null && detail_service != null">
          <b-row>
            <b-col cols="4">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>Customer ID </label>
                 
                  <Select2
                    :disabled="true"
                    class="remove"
                    v-model="shipment_on_fast.fast_company_id"
                    :options="
                      companyItems.map((e) => {
                        return {
                          ...e,
                          // fast_id - acronym
                         text: e.fast_id + ' - ' + e.acronym,
                        };
                      })
                    "
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider
                name="Salesman"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Salesman </label>
                  <!-- <Select2
                    :disabled="readonlyFrom"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    v-model="shipment_on_fast.fast_sale_id"
                    :options="sales_list_id_fast"
                  /> -->
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonlyFrom"
                    placeholder="Salesman"
                    v-model="shipment_on_fast.fast_sale_id"
                    :options="sales_list_id_fast"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider
                name="Accountant ID"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Accountant ID </label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonlyFrom"
                    placeholder="Accountant ID"
                    v-model="shipment_on_fast.accountant"
                    :options="sales_list_id_fast"
                  />
                  <!-- <b-form-input
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonlyFrom"
                    placeholder="Accountant ID"
                    v-model="shipment_on_fast.accountant"
                  /> -->
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Shipper"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Shipper </label>
                  <div class="d-flex">
                    <Select3
                      v-model="shipment_on_fast.shipper"
                      :disabled="readonlyFrom"
                      @select="
                        ({ name, Address }) => {
                          shipment_on_fast.shipper_name = name;
                          shipment_on_fast.shipper_address = Address;
                        }
                      "
                      :options="{
                        value: 'id',
                        label: 'name',
                        url: 'masterData?data=ShipperConsignee',
                        fields: [
                          { field: 'name', label: 'Name' },
                          {
                            field: 'Address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />
                    <b-button
                      variant="primary"
                      :disabled="readonlyFrom"
                      v-b-tooltip.hover
                      title="Data synchronization with FAST"
                      @click="getDataShipper"
                      :key="buttonKey"
                      class="btn-icon ml-1"
                    >
                      <feather-icon icon="RefreshCwIcon" />
                    </b-button>
                  </div>

                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Consignee"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Consignee </label>

                  <Select3
                    v-model="shipment_on_fast.consignee"
                    :disabled="readonlyFrom"
                    @select="
                      ({ name, Address }) => {
                        shipment_on_fast.consignee_name = name;
                        shipment_on_fast.consignee_address = Address;
                      }
                    "
                    :options="{
                      value: 'id',
                      label: 'name',
                      url: 'masterData?data=ShipperConsignee',
                      fields: [
                        { field: 'name', label: 'Name' },
                        {
                          field: 'Address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>Commodity </label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonlyFrom"
                    placeholder="Commodity"
                    v-model="shipment_on_fast.goods_type"
                    @select="
                      ({ name }) => {
                        shipment_on_fast.goods_type_name = name;
                      }
                    "
                    :options="goods_types"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Commodity description"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Commodity description </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_fast.mo_ta"
                    placeholder="Commodity description"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </div>
        <!--Air-->
        <div v-if="service_type == 1 && detail_service != null">
          <b-row>
            <b-col cols="6">
              <validation-provider name="ETD" #default="{ errors }" rules="">
                <b-form-group>
                  <label>ETD </label>
                  <b-form-datepicker
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_fast.etd"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="vi-VN"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider name="ETA" #default="{ errors }" rules="">
                <b-form-group>
                  <label>ETA</label>
                  <b-form-datepicker
                    :state="errors.length > 0 ? false : null"
                    v-model="shipment_on_fast.eta"
                    :disabled="readonlyFrom"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="vi-VN"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>Pickup </label>

                  <Select4
                    v-model="shipment_on_fast.pickup_location"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Enter Pickup "
                    :key="loadLocations"
                    @reload="fetchLocations"
                    :disabled="readonlyFrom"
                    :options="{
                      value: 'id',
                      isSearch: true,
                      isReload: true,
                      label: 'text',
                      data: locations,
                      fields: [
                        { field: 'abbreviations', label: 'Abbreviations' },
                        { field: 'name', label: 'Location' },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Delivery"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Delivery </label>

                  <Select4
                    v-model="shipment_on_fast.delivery_location"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Enter delivery "
                    :disabled="readonlyFrom"
                    :key="loadLocations"
                    @reload="fetchLocations"
                    :options="{
                      isSearch: true,
                      isReload: true,
                      value: 'id',
                      label: 'text',
                      data: locations,
                      fields: [
                        { field: 'abbreviations', label: 'Abbreviations' },
                        { field: 'name', label: 'Location' },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- test -->
            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>AOL </label>
                  <!-- <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonlyFrom"
                    placeholder="AOL"
                    v-model="shipment_on_fast.pol_port"
                    :options="ports"
                  /> -->
                  <Select4
                    v-model="shipment_on_fast.pol_port"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="AOL"
                    :disabled="readonlyFrom"
                    :options="{
                      value: 'code',
                      isSearch: true,
                      label: 'name',
                      data: ports,
                      fields: [
                        { field: 'code', label: 'Code' },
                        { field: 'name', label: 'Name' },
                        { field: 'type', label: 'Service' },
                        {
                          field: 'country_code',
                          label: 'Country Code',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>AOD </label>
                  <!-- <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonlyFrom"
                    placeholder="AOD"
                    v-model="shipment_on_fast.pod_port"
                    :options="ports"
                  /> -->
                  <Select4
                    v-model="shipment_on_fast.pod_port"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="AOD"
                    :disabled="readonlyFrom"
                    :options="{
                      value: 'code',
                      isSearch: true,
                      label: 'name',
                      data: ports,
                      fields: [
                        { field: 'code', label: 'Code' },
                        { field: 'name', label: 'Name' },
                        { field: 'type', label: 'Service' },
                        {
                          field: 'country_code',
                          label: 'Country Code',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider name="Flight" #default="{ errors }" rules="">
                <b-form-group>
                  <label>Flight </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_fast.flight"
                    placeholder="Flight"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider
                name="Gross Weight"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Gross Weight </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_fast.trong_luong"
                    placeholder="Gross Weight"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider name="Volume" #default="{ errors }" rules="">
                <b-form-group>
                  <label>Volume (CBM) </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_fast.so_khoi"
                    placeholder="Volume (CBM)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label>Shipment Note</label>
                <b-form-textarea
                  :disabled="readonlyFrom"
                  v-model="shipment_on_fast.notes"
                  placeholder="Notes"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" class="pt-1 pb-1">
              <a
                @click="sendNewShipmentToFast"
                v-if="!readonlyFrom"
                class="btn round btn-primary pl-3 pr-3"
              >
                <feather-icon icon="SendIcon" /> Send To FAST
              </a>
            </b-col>
          </b-row>
        </div>
        <!--FCL LCL-->
        <div
          v-if="
            (service_type == 2 || service_type == 3) && detail_service != null
          "
        >
          <b-row>
            <!-- TNLONG 09/08/2022-->

            <b-col cols="6">
              <validation-provider name="ETD" #default="{ errors }" rules="">
                <b-form-group>
                  <label>ETD </label>
                  <b-form-datepicker
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_fast.etd"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="vi-VN"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider name="ETA" #default="{ errors }" rules="">
                <b-form-group>
                  <label>ETA </label>
                  <b-form-datepicker
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_fast.eta"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="vi-VN"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="6">
              <validation-provider name="Pickup" #default="{ errors }" rules="">
                <b-form-group>
                  <label>Pickup </label>

                  <Select4
                    v-model="shipment_on_fast.pickup_location"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Enter Pickup "
                    :disabled="readonlyFrom"
                    :key="loadLocations"
                    @reload="fetchLocations"
                    :options="{
                      value: 'id',
                      isSearch: true,
                      isReloaod: true,
                      label: 'text',
                      data: locations,
                      fields: [
                        { field: 'abbreviations', label: 'Abbreviations' },
                        { field: 'name', label: 'Location' },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Delivery"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Delivery </label>

                  <Select4
                    v-model="shipment_on_fast.delivery_location"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Enter Delivery "
                    :disabled="readonlyFrom"
                    :key="loadLocations"
                    @reload="fetchLocations"
                    :options="{
                      value: 'id',
                      isSearch: true,
                      isReload: true,
                      label: 'text',
                      data: locations,
                      fields: [
                        { field: 'abbreviations', label: 'Abbreviations' },
                        { field: 'name', label: 'Location' },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="6">
              <validation-provider name="POL" #default="{ errors }" rules="">
                <b-form-group>
                  <label>POL </label>
                  <div class="d-flex">
                    <!-- <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonlyFrom"
                      placeholder="POL"
                      class="w-100"
                      v-model="shipment_on_fast.pol_port"
                      :options="ports"
                    /> -->
                    <Select4
                      v-model="shipment_on_fast.pol_port"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="POL"
                      :disabled="readonlyFrom"
                      :options="{
                        value: 'code',
                        isSearch: true,
                        label: 'name',
                        data: ports,
                        fields: [
                          { field: 'code', label: 'Code' },
                          { field: 'name', label: 'Name' },
                          { field: 'type', label: 'Service' },
                          {
                            field: 'country_code',
                            label: 'Country Code',
                          },
                        ],
                      }"
                    />
                    <!-- <b-button variant="primary" :disabled="readonlyFrom" v-b-tooltip.hover
                      title="Data synchronization with FAST" @click.once="getDataPolPod" :key="buttonKey"
                      class="btn-icon ml-1">
                      <feather-icon icon="RefreshCwIcon" />
                    </b-button> -->
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider name="POD" #default="{ errors }" rules="">
                <b-form-group>
                  <label>POD </label>
                  <!-- <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonlyFrom"
                    placeholder="POD"
                    v-model="shipment_on_fast.pod_port"
                    :options="ports"
                  /> -->
                  <Select4
                    v-model="shipment_on_fast.pod_port"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="POD"
                    :disabled="readonlyFrom"
                    :options="{
                      value: 'code',
                      label: 'name',
                      isSearch: true,
                      data: ports,
                      fields: [
                        { field: 'code', label: 'Code' },
                        { field: 'name', label: 'Name' },
                        { field: 'type', label: 'Service' },
                        {
                          field: 'country_code',
                          label: 'Country Code',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" v-if="service_type == 3">
              <validation-provider
                name="Place of Delivery"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Place of Delivery </label>
                  <div class="d-flex">
                    <!-- <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonlyFrom"
                      placeholder="Place of Delivery"
                      class="w-100"
                      v-model="shipment_on_fast.placeOfDelivery"
                      :options="ports"
                    /> -->
                    <Select4
                      v-model="shipment_on_fast.placeOfDelivery"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="Place of Delivery"
                      :disabled="readonlyFrom"
                      :options="{
                        value: 'code',
                        isSearch: true,
                        label: 'name',
                        data: ports,
                        fields: [
                          { field: 'code', label: 'Code' },
                          { field: 'name', label: 'Name' },
                          { field: 'type', label: 'Service' },
                          {
                            field: 'country_code',
                            label: 'Country Code',
                          },
                        ],
                      }"
                    />
                  </div>

                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Gross Weight"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Gross Weight </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_fast.trong_luong"
                    placeholder="Gross Weight"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider name="Volume" #default="{ errors }" rules="">
                <b-form-group>
                  <label>Volume (CBM) </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_fast.so_khoi"
                    placeholder="Volume (CBM)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!--only fcl-->
            <b-col cols="6" v-if="shipment_on_fast.service_type == 2">
              <validation-provider name="Vessel" #default="{ errors }" rules="">
                <b-form-group>
                  <label>Vessel </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_fast.vessel"
                    placeholder="Vessel"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6" v-if="shipment_on_fast.service_type == 2">
              <validation-provider name="Voyage" #default="{ errors }" rules="">
                <b-form-group>
                  <label>Voyage </label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_fast.voyage"
                    placeholder="Voyage"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12">
              <b-form-group>
                <label>Shipment Note</label>
                <b-form-textarea
                  :disabled="readonlyFrom"
                  v-model="shipment_on_fast.notes"
                  placeholder="Notes"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" class="pt-1 pb-1">
              <a
                @click="sendNewShipmentToFast"
                v-if="!readonlyFrom"
                class="btn round btn-primary pl-3 pr-3"
              >
                <feather-icon icon="SendIcon" /> Send To FAST
              </a>
            </b-col>
          </b-row>
        </div>
        <!--custom-->
        <div v-if="service_type == 4 && detail_service != null">
          <b-row>
            <b-col cols="6">
              <validation-provider name="POL" #default="{ errors }" rules="">
                <b-form-group>
                  <label>POL</label>
                  <div class="d-flex">
                    <!-- <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonlyFrom"
                      placeholder="POL"
                      class="w-100"
                      v-model="shipment_on_fast.pol_port"
                      :options="ports"
                    /> -->
                    <Select4
                      v-model="shipment_on_fast.pol_port"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="POL"
                      :disabled="readonlyFrom"
                      :options="{
                        value: 'code',
                        label: 'name',
                        isSearch: true,
                        data: ports,
                        fields: [
                          { field: 'code', label: 'Code' },
                          { field: 'name', label: 'Name' },
                          { field: 'type', label: 'Service' },
                          {
                            field: 'country_code',
                            label: 'Country Code',
                          },
                        ],
                      }"
                    />
                    <!-- <b-button variant="primary" :disabled="readonlyFrom" v-b-tooltip.hover
                      title="Data synchronization with FAST" @click.once="getDataPolPod" :key="buttonKey"
                      class="btn-icon ml-1">
                      <feather-icon icon="RefreshCwIcon" />
                    </b-button> -->
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider name="POD" #default="{ errors }" rules="">
                <b-form-group>
                  <label>POD</label>
                  <!-- <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonlyFrom"
                    placeholder="POD"
                    v-model="shipment_on_fast.pod_port"
                    :options="ports"
                  /> -->
                  <Select4
                    v-model="shipment_on_fast.pod_port"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="POD"
                    :disabled="readonlyFrom"
                    :options="{
                      value: 'code',
                      isSearch: true,
                      label: 'name',
                      data: ports,
                      fields: [
                        { field: 'code', label: 'Code' },
                        { field: 'name', label: 'Name' },
                        { field: 'type', label: 'Service' },
                        {
                          field: 'country_code',
                          label: 'Country Code',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider name="ETD" #default="{ errors }" rules="">
                <b-form-group>
                  <label>ETD </label>
                  <b-form-datepicker
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_fast.etd"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="vi-VN"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider name="ETA" #default="{ errors }" rules="">
                <b-form-group>
                  <label>ETA</label>
                  <b-form-datepicker
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_fast.eta"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="vi-VN"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- test -->
            <b-col cols="6">
              <validation-provider name="" #default="{ errors }" rules="">
                <b-form-group>
                  <label>Pickup </label>

                  <Select4
                    v-model="shipment_on_fast.pickup_location"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Enter Pickup "
                    :disabled="readonlyFrom"
                    :key="loadLocations"
                    @reload="fetchLocations"
                    :options="{
                      value: 'id',
                      label: 'text',
                      isSearch: true,
                      isReload: true,
                      data: locations,
                      fields: [
                        { field: 'abbreviations', label: 'Abbreviations' },
                        { field: 'name', label: 'Location' },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>Delivery</label>

                  <Select4
                    v-model="shipment_on_fast.delivery_location"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Enter Delivery "
                    :disabled="readonlyFrom"
                    :key="loadLocations"
                    @reload="fetchLocations"
                    :options="{
                      isSearch: true,
                      isReload: true,
                      value: 'id',
                      label: 'text',
                      data: locations,
                      fields: [
                        { field: 'abbreviations', label: 'Abbreviations' },
                        { field: 'name', label: 'Location' },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12">
              <b-form-group>
                <label>Shipment Note</label>
                <b-form-textarea
                  :disabled="readonlyFrom"
                  v-model="shipment_on_fast.notes"
                  placeholder="Notes"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" class="pt-1 pb-1">
              <a
                @click="sendNewShipmentToFast"
                v-if="!readonlyFrom"
                class="btn round btn-primary pl-3 pr-3"
              >
                <feather-icon icon="SendIcon" /> Send To FAST
              </a>
            </b-col>
          </b-row>
        </div>
        <!--van cont-->
        <div
          v-if="
            (service_type == 5 || service_type == 6) && detail_service != null
          "
        >
          <b-row>
            <b-col cols="6">
              <validation-provider name="ETD" #default="{ errors }" rules="">
                <b-form-group>
                  <label>ETD </label>
                  <b-form-datepicker
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonlyFrom"
                    v-model="shipment_on_fast.etd"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="vi-VN"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider name="ETA" #default="{ errors }" rules="">
                <b-form-group>
                  <label>ETA </label>
                  <b-form-datepicker
                    :disabled="readonlyFrom"
                    :state="errors.length > 0 ? false : null"
                    v-model="shipment_on_fast.eta"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="vi-VN"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- test -->
            <b-col cols="6">
              <validation-provider name="Pickup" #default="{ errors }" rules="">
                <b-form-group>
                  <label>Pickup </label>

                  <Select4
                    v-model="shipment_on_fast.pickup_location"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :key="loadLocations"
                    @reload="fetchLocations"
                    placeholder="Enter Pickup "
                    :disabled="readonlyFrom"
                    :options="{
                      value: 'id',
                      isSearch: true,
                      isReload: true,
                      label: 'text',
                      data: locations,
                      fields: [
                        { field: 'abbreviations', label: 'Abbreviations' },
                        { field: 'name', label: 'Location' },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Delivery"
                #default="{ errors }"
                rules=""
              >
                <b-form-group>
                  <label>Delivery </label>

                  <Select4
                    v-model="shipment_on_fast.delivery_location"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Enter delivery "
                    :disabled="readonlyFrom"
                    :key="loadLocations"
                    @reload="fetchLocations"
                    :options="{
                      value: 'id',
                      isSearch: true,
                      isReload: true,
                      label: 'text',
                      data: locations,
                      fields: [
                        { field: 'abbreviations', label: 'Abbreviations' },
                        { field: 'name', label: 'Location' },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12">
              <b-form-group>
                <label>Shipment Note</label>
                <b-form-textarea
                  :disabled="readonlyFrom"
                  v-model="shipment_on_fast.notes"
                  placeholder="Notes"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" class="pt-1 pb-1">
              <a
                @click="sendNewShipmentToFast"
                v-if="!readonlyFrom"
                class="btn round btn-primary pl-3 pr-3"
              >
                <feather-icon icon="SendIcon" /> Send To FAST
              </a>
            </b-col>
          </b-row>
        </div>
      </validation-observer>
    </div>
  </div>
</template>
<style scoped>
.hide_select {
  width: 100%;
}
</style>
<style>
.red {
  color: red;
}

.vue-dropzone > .dz-preview .dz-details {
  background-color: #2b938c;
  border-radius: 15px;
}
</style>
<script>
import {
  BButton,
  BFormInput,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
  BCardText,
} from "bootstrap-vue";
import Select2 from "v-select2-component";
import useJwt from "@/auth/jwt/useJwt";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState, mapActions } from "vuex";
import { checkDateToFormatDynamic } from "@/utils/format";

import { $ctx } from "@themeConfig";
import moment from "moment";

export default {
  props: {
    cards: {},
    className: { default: "booking-online" },
    readonly: { default: false, type: Boolean },
    request_quotation: { default: null },
    booking: { default: null },
  },
  components: {
    BButton,
    ValidationProvider,
    BCardText,
    ValidationObserver,
    BFormInput,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardText,
    Select2,
    vueDropzone: vue2Dropzone,
    FeatherIcon,
  },
  data() {
    return {
      loadLocations: 1,
      shipment_detail: null,
      reloadFast: 1,
      buttonKey: 1,
      select2Settings: null,
      userData: JSON.parse(localStorage.getItem("userData")),
      dropzoneOptions: {
        url: $ctx.API_URL + "uploadFile",
        addRemoveLinks: true,
        createImageThumbnails: false,
        headers: { apiKey: localStorage.getItem("accessToken") },
      },
      service_type: null,
      detail_service: null,
      customer_list: null,
      sales_list: null,
      sales_list_id_fast: null,
      // request_quotation:{
      //   pickup_location: null,
      //   other_pickup_location: null,
      // },
      fast_services: [
        { id: "1", text: "Import (Air)", service_type: 1 },
        { id: "2", text: "Export (Air)", service_type: 1 },
        { id: "3", text: "Import (Sea FCL)", service_type: 2 },
        { id: "4", text: "Export (Sea FCL)", service_type: 2 },
        { id: "5", text: "Import (Consol)", service_type: 3 },
        { id: "6", text: "Export (Consol)", service_type: 3 },
        { id: "7", text: "Import", service_type: 3 },
        { id: "8", text: "Export", service_type: 3 },
        { id: "9", text: "Logistics", service_type: 4 },
        { id: "10", text: "Inland Trucking", service_type: 5 },
        { id: "11", text: "Inland Trucking", service_type: 6 },
      ],
      shipment_on_fast: {
        etd: null,
        eta: null,
      },
    };
  },

  created() {
    this.readonlyFrom = this.readonly;

    this.select2Settings = this.getSelect2Settings({
      url: $ctx.API_URL + "masterData?data=ShipperConsignee",
      field_name: "title",
      placeholder: "Enter",
      term_name: "search",
    });
    this.getSelect2Settings({
      url: $ctx.API_URL + "masterData?data=ShipperConsignee",
      field_name: "title",
      placeholder: "Enter",
      term_name: "search",
    });
  },
  computed: {
    ...mapState("masterData", [
      "service_types",
      "locations",
      "ports",
      "goods_types",
      "sales",
      "companyItems",
    ]),
  },
  mounted() {
    useJwt.get("masterData?data=Saler", {}).then((response) => {
      this.sales_list = this.formatOption(response.data.result);
      this.sales_list_id_fast = this.formatOptionSale(response.data.result);
    });

    // useJwt.get("masterData?data=All", {}).then((response) => {
    //   this.service_types = response.data.result.ServiceType;
    //   this.ports = this.formatOption(response.data.result.Port);
    //   this.locations = response.data.result.Location;
    //   this.goods_types = response.data.result.GoodsType;
    // });
    useJwt.get("wr1?objectType=CustomerList", {}).then((response) => {
      this.customer_list = this.formatOptionSale(response.data.result);
    });

    this.shipment_on_fast.pricing = this.booking;
    this.shipment_on_fast.id = this.request_quotation.id;
    this.shipment_on_fast.fast_sale_id =
      !!this.request_quotation?.sale_id &&
      this.request_quotation?.sale_id.toLowerCase().trim() == "admin"
        ? ""
        : this.request_quotation.sale_id;
    // this.shipment_on_fast.fast_company_id = this.request_quotation.company_id;

    this.shipment_on_fast.fast_company_id = this.request_quotation.company_id;

    this.service_type = this.request_quotation.service_type;
    this.shipment_on_fast.notes = this.request_quotation.notes;

    if (
      (this.request_quotation.service_type == 5 ||
        this.request_quotation.service_type == 6) &&
      this.shipment_on_fast.eta == null &&
      this.shipment_on_fast.etd == null
    ) {
      if (this.request_quotation?.has_customs) {
        this.fast_services.filter((item) => {
          if (item.id == "9") {
            item.service_type = this.request_quotation.service_type;
          }
        });

        this.detail_service = "9";
      } else {
        this.fast_services.filter((item) => {
          if (item.id == "9") {
            item.service_type = 4;
          }
        });
        this.detail_service =
          this.request_quotation.service_type == 5
            ? "10"
            : this.request_quotation.service_type == 6
            ? "11"
            : "";
      }
    }

    useJwt
      .get("wr1?objectType=GetBookingDetail", {
        params: { search: { id: this.request_quotation.id } },
      })
      .then((response) => {
        if (response.data.result.shipment_on_fast_info != null) {
          this.shipment_on_fast = JSON.parse(
            response.data.result.shipment_on_fast_info
          );
          this.service_type = this.shipment_on_fast.service_type;
          this.detail_service = this.shipment_on_fast.detail_service;
          this.readonlyFrom = true;
        } else {
          this.readonlyFrom = this.readonly;
          this.loadDefaultInfo();
        }

        if (response.data.result.shipment_detail != null) {
          this.shipment_detail = JSON.parse(
            response.data.result.shipment_detail
          );

          if (
            this.request_quotation.service_type.toString() == "5" ||
            this.request_quotation.service_type.toString() == "6"
          ) {
            this.shipment_on_fast.notes =
              this.shipment_detail.notes_truck || this.shipment_detail.notes;
          } else if (this.request_quotation.service_type.toString() == "3") {
            this.shipment_on_fast.notes =
              this.shipment_detail.notes_truck || this.shipment_detail.notes;
          }
        } else {
          if (
            this.request_quotation.service_type.toString() == "5" ||
            this.request_quotation.service_type.toString() == "6"
          ) {
            this.shipment_on_fast.notes = this.request_quotation.notes_truck;
          } else {
            this.shipment_on_fast.notes = this.request_quotation.notes;
          }
        }
      });
  },
  methods: {
    async fetchLocations() {
      await this.$store.dispatch("masterData/fetchLocations");
    },
    async getDataPolPod() {
      try {
        const data = await this.$store.dispatch("masterData/fetchPortsType");
        if (data && data.result == 1) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("Successfully synchronized to FAST"),
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("quotationSaveError"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.message,
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }

      setTimeout(() => {
        this.buttonKey++;
      }, 5000);
    },
    async getDataShipper() {
      console.log("getDataShipper");
      this.$loading.show();
      try {
        const data = await this.$store.dispatch("masterData/fetchShipperType");
        if (data && data.result == 1) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("Successfully synchronized to FAST"),
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("quotationSaveError"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.message,
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.$loading.hide();
      }

      setTimeout(() => {
        this.buttonKey++;
      }, 3000);
    },
    myChangeEventShipper(e) {
      this.shipment_on_fast.shipper_name = e.name;
      this.shipment_on_fast.shipper_address = e.Address;
    },
    getSelect2Settings(options = {}) {
      return {
        ajax: {
          headers: { apiKey: localStorage.getItem("accessToken") },
          cache: true,
          delay: 200,
          url: options.url,
          data: function (params) {
            return Object.assign(
              {
                [options.term_name || options.field_name]: params.term,
                page: params.page,
              },
              options.params || {}
            );
          },
          processResults: function processResults(data, params) {
            params.page = params.page || 1;
            return {
              results: data.result,
              pagination: {
                more: params.page * data.per_page < data.total,
              },
            };
          },
        },
        allowClear: true,
        multiple: options.multiple || false,
        placeholder: options.placeholder,
      };
    },
    formatOption(arr) {
      const mapData = arr.map((obj) => {
        obj.text = obj.text || obj.name;
        obj.id = obj.code;
        return obj;
      });
      return mapData;
    },
    formatOptionSale(arr) {
      var mapData = [];

      arr.forEach((obj) => {
        if (obj.fast_id) {
          obj.text = obj.code + " - " + obj.name;
          obj.id = obj.code;
          return (mapData = [...mapData, obj]);
        }
      });
      return mapData;
    },
    formatOptionKH(arr) {
      const mapData = arr.map((obj) => {
        obj.text = obj.fast_id;
        obj.id = obj.code;
        return obj;
      });
      return mapData;
    },
    loadDefaultInfo() {
      // console.log(this.request_quotation);
      this.shipment_on_fast.service_type = this.service_type;
      this.shipment_on_fast.detail_service = this.detail_service;
      this.shipment_on_fast.etd = checkDateToFormatDynamic(
        this.request_quotation.etd,
        "YYYY-MM-DD"
      );
      this.shipment_on_fast.eta = checkDateToFormatDynamic(
        this.request_quotation.eta,
        "YYYY-MM-DD"
      );

      this.shipment_on_fast.goods_type = this.request_quotation.goods_type;

      this.shipment_on_fast.goods_type_name = this.goods_types.find(
        (e) => e.id == this.request_quotation.goods_type
      )
        ? this.goods_types.find(
            (e) => e.id == this.request_quotation.goods_type
          ).name
        : "";

      this.shipment_on_fast.mo_ta = this.request_quotation.mo_ta;
      this.shipment_on_fast.pol_port = this.request_quotation.pol_port;
      this.shipment_on_fast.pod_port = this.request_quotation.pod_port;
      // this.shipment_on_fast.trong_luong = this.request_quotation?.showAddMore?.[0].showAddMoreLine?.[0].gross_weight;// long fix
      // this.shipment_on_fast.so_khoi =this.request_quotation?.showAddMore?.[0].showAddMoreLine?.[0].volume ;// long fix
      if (this.request_quotation.service_type == "5") {
        this.shipment_on_fast.trong_luong =
          this.request_quotation?.valueContainer?.[0].ContainerLine?.[0].total_gross_weight; // long fix
        this.shipment_on_fast.cont_type =
          this.request_quotation?.valueContainer?.[0].ContainerLine?.[0].cont_type;
      } else if (this.request_quotation.service_type == "3") {
        this.shipment_on_fast.trong_luong =
          this.request_quotation?.showAddMore?.[0].showAddMoreLine?.[0].gross_weight; // long fix
        this.shipment_on_fast.so_khoi =
          this.request_quotation?.showAddMore?.[0].showAddMoreLine?.[0].volume; // long fix
      }

      this.shipment_on_fast.pickup_location =
        this.request_quotation.pickup_location;
      this.shipment_on_fast.delivery_location =
        this.request_quotation.delivery_location;

      this.reloadFast++;
    },
    async sendNewShipmentToFast() {
      this.shipment_on_fast.detail_service = this.detail_service;
      this.shipment_on_fast.service_type = this.service_type;
      this.shipment_on_fast.pickup = this.locations.find(
        (e) => e.id == this.shipment_on_fast.pickup_location
      )
        ? this.locations.find(
            (e) => e.id == this.shipment_on_fast.pickup_location
          ).abbreviations +
          " - " +
          this.locations.find(
            (e) => e.id == this.shipment_on_fast.pickup_location
          ).address
        : "";
      this.shipment_on_fast.delivery = this.locations.find(
        (e) => e.id == this.shipment_on_fast.delivery_location
      )
        ? this.locations.find(
            (e) => e.id == this.shipment_on_fast.delivery_location
          ).abbreviations +
          " - " +
          this.locations.find(
            (e) => e.id == this.shipment_on_fast.delivery_location
          ).address
        : "";
      // 0/06/24 14:00
      this.shipment_on_fast.delivery_date =
        this.request_quotation.delivery_date &&
        this.request_quotation.delivery_date != " "
          ? moment(
              this.request_quotation.delivery_date,
              "DD/MM/YY mm:ss"
            ).format("YYYY-MM-DD")
          : moment(this.request_quotation.deliveryDate, "DD/MM/YY").format(
              "YYYY-MM-DD"
            );

      var validate = await this.$refs.shipmentRules
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      this.$loading.show();
      useJwt
        .put("wr1?objectType=NewShipmentToFast", this.shipment_on_fast)
        .then((response) => {
          if (response.data.code == 200) {
            this.$emit("NewShipmentToFast", response.data.meta?.status || 0);

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Send Shipment to Fast success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Send Shipment to Fast error!",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Send Shipment to Fast error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.$loading.hide();
        });
    },
  },

  watch: {
    locations: {
      handler: function (val, oldVal) {
        this.loadLocations++;
      },
      deep: true,
    },
  },
};
</script>
